import { useLazyQuery } from "@apollo/client";
import { BusinessAddressQuery, BusinessAddressQueryVariables } from "@ctypes";
import { BUSINESS_ADDRESS } from "@graphql";

export const useBusinessAddress = () => {
  return useLazyQuery<BusinessAddressQuery, BusinessAddressQueryVariables>(BUSINESS_ADDRESS);
};
